// extracted by mini-css-extract-plugin
export default {"blockItem":"BlockItem_blockItem__lh8jh"};